import {
  GET_ANALYSIS_LIST_IN_PROGRESS,
  GET_ANALYSIS_LIST_SUCCESS,
  GET_ANALYSIS_LIST_FAIL,
  MARK_ANALYSIS_AS_VIEWED_SUCCESS,
} from "../constants";
import { LOGOUT } from "../../authentication/constants";

const initialState = {
  list: [],
  inProgress: false,
  error: false,
};

/**
 * Installations reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function analysis(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_ANALYSIS_LIST_IN_PROGRESS:
      return {
        ...state,
        inProgress: true,
        error: false,
      };

    case GET_ANALYSIS_LIST_SUCCESS:
      return {
        ...state,
        list: payload.list,
        inProgress: false,
      };

    case GET_ANALYSIS_LIST_FAIL:
      return {
        ...state,
        inProgress: false,
        error: true,
      };

    case MARK_ANALYSIS_AS_VIEWED_SUCCESS:
      return {
        ...state,
        list: state.list.map((analysis) => {
          if (analysis.uuid === payload.uuid) {
            return {
              ...analysis,
              resultViewedAt: new Date(),
              hasResultToView: false,
            };
          }

          return analysis;
        }),
      };

    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
